import React from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import SimpleUploadModal from "../Modals/SimpleUploadModal.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import useResetUploader from "../Helpers/useResetUploader.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";

const GoBackComponent = () => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();
  const { uploaderGetFiles } = useUploader();

  const handleResetUploader = useResetUploader();
  const { mobileCondition } = useMediaQueries();

  const handleClick = () => {
    if (uploaderGetFiles().length === 0) {
      handleResetUploader();
      return;
    }

    setModal({
      modal: SimpleUploadModal,
      props: {
        icon: { name: "home/house-circle" },
        text: "go-back-home-uploader-text",
        subText: "go-back-home-uploader-sub-text",
        buttonText: "go-back-home-uploader-button-text",
        buttonCallback: handleResetUploader,
        isCancel: true,
      },
    });
  };

  return mobileCondition ? (
    <div className="restart-section" onClick={handleClick}>
      <Icon name="arrow-back" darkGray /> {getTextByKey("back-text")}
    </div>
  ) : (
    <button className="back-dropzone-button" onClick={handleClick}>
      <Tooltip tooltipTextKey="back-text">
        <Icon name="arrow-back" white />
      </Tooltip>
      <div>{getTextByKey("back-text")}</div>
    </button>
  );
};

export default GoBackComponent;
